import React from "react";
import styles from './StatusBadge.module.css';

interface StatusBadgeProps {
  status?: "info" | "success" | "warning" | "danger" | "neutral";
  label: React.ReactNode;
  style?: any;
  className?: string;
}

export default function StatusBadge(props: StatusBadgeProps) {
  const { label, status = "neutral", ...rest } = props;

  return (
    <div {...rest} className={`${styles.root} ${props.className}`} data-status={status}>
      {label}
    </div>
  );
}
